import CatalogTriggersCards from '../../components/CatalogTriggers/CatalogTriggerCards';
import ListingPage from '../../components/ListingPage';

const CatalogTriggersPage = () => {
  return (
    <ListingPage
      entityType="catalogTrigger"
      filterBy="name"
      useStats={true}
      Cards={CatalogTriggersCards}
      createRestrictionKey="catalogTriggersCreate"
    />
  );
};

export default CatalogTriggersPage;
